import { ISSUE_FIELD_DATE_CF_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { FieldTransformer } from '../types/transformer-type.tsx';
import { transformAggNodeToLegacyField } from './default-node-transformer.tsx';
import isFieldMissingRenderer from './helpers/is-field-missing-renderer.tsx';

export const transformAggForgeDateToLegacyField: FieldTransformer = (node) => {
	if (isFieldMissingRenderer(node)) {
		return undefined;
	}
	return {
		...transformAggNodeToLegacyField(node),
		value: node.date,
		autoCompleteUrl: null,
		schema: {
			configuration: null,
			items: null,
			system: null,
			custom: node.type,
			renderer: node.renderer,
			type: ISSUE_FIELD_DATE_CF_TYPE,
		},
	};
};
